import { Card, Text, Title } from '@mantine/core';
import React, { useContext, useEffect, useState } from 'react';
import FormNikActivatedBulk from '../../components/forms/FormNikActivatedBulk';
import { actionUpdateNikStatusBulk, clearRedux, fetchCheckStatusBulk } from './action';
import { useDispatch, useSelector } from 'react-redux';
import { useTimer } from 'react-timer-hook';
import RenderModal from './modal';
import { AppContext, ToastrContext } from '../../contexts';
import { useNavigate } from 'react-router-dom';
import { useScheduledPolling } from '../../utils/hooks';
import { RenderModalLimitMaxCsv } from '../MAPFeatureActivation/Modal';

const NikActivateBulk = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    updateNikStatusBulk,
    dataCheckStatusBulk
  } = useSelector((state) => state.nikManagement);

  const { setBreadcrumbs } = useContext(AppContext);
  const { setToastr } = useContext(ToastrContext);

  const [isTooManyRequests, setIsTooManyRequests] = useState(false);
  const [modal, setModal] = useState({
    variant: '',
    opened: false
  });
  const { startPolling, stopPolling, secondsElapsed } = useScheduledPolling({
    action: (requestId) => dispatch(fetchCheckStatusBulk(requestId)),
    interval: 5000,  // Fetch every 5s
    duration: 30000, // Stop after 30s
    onComplete: () => { }
  });
  const dateNow = new Date();
  const { minutes, seconds, restart } =
    useTimer({
      expiryTimestamp: dateNow,
      onExpire: () => {
        dispatch(clearRedux('updateNikStatusBulk'));
        setIsTooManyRequests(false);
      },
      autoStart: false
    });

  const statusResponseBulkHandler = (response) => {
    if (response.success) {
      setModal({
        actionType: 'block',
        variant: 'processing_bulk',
        opened: true
      });
      const requestId = response?.data?.id;
      if (requestId) {
        startPolling(requestId);
      }
      // setIsBlocked(false);
    } else if (response.status === 'CSV_MAX_LIMIT') {
      setModal({
        variant: 'limitCsv',
        opened: true
      });
      // setIsBlocked(false);
    }
    else if (response.status === 'TOO_MANY_REQUEST') {
      setToastr({
        visible: true,
        type: 'danger',
        desc: response?.message || 'Terlalu banyak permintaan, silakan coba lagi nanti'
      });
      const newExpiry = new Date();
      newExpiry.setSeconds(newExpiry.getSeconds() + response?.data?.countdownTime);
      restart(newExpiry);
      setIsTooManyRequests(true);
      // setIsBlocked(false);
    }
  };

  const handledNikActivatedBulk = (data) => {
    const formData = new FormData();
    formData.append('actionType', 'unblock');
    formData.append('file', data?.file[0]);
    formData.append('reasonDetailMessage', data?.activateReason);
    formData.append('supportDocument', data.supportDocument || null);
    dispatch(actionUpdateNikStatusBulk(formData, statusResponseBulkHandler));
  };

  useEffect(() => {
    if (dataCheckStatusBulk?.data?.totalProcess <= 0) {
      stopPolling();
      navigate('/customer-setting/status/unblock');
      dispatch(clearRedux('dataCheckStatusBulk'));
    }
  }, [dataCheckStatusBulk]);

  useEffect(() => {
    setBreadcrumbs([
      { name: 'Blokir & Aktifkan NIK', to: '/customer-setting' },
      'Aktifkan NIK Pelanggan'
    ]);
    dispatch(clearRedux('updateNikStatusBulk'));
    dispatch(clearRedux('dataCheckStatusBulk'));
  }, []);
  return (
    <Card withBorder>
      <Title fz={30} order={4}>Aktifkan NIK Pelanggan Sekaligus</Title>
      <Text c="#52575C" fz={18}>Aktifkan NIK pelanggan sekaligus dengan
        template CSV berdasarkan nomor NIK pelanggan.</Text>
      <FormNikActivatedBulk
        handleSubmit={handledNikActivatedBulk}
        isLoading={updateNikStatusBulk.isLoading}
        isTooManyRequests={isTooManyRequests}
        minute={minutes}
        second={seconds}
      />

      {modal.variant === 'processing_bulk' &&
        <RenderModal
          actionType="block"
          countDownStatus={secondsElapsed}
          handledCloseModal={() => { }}
          handleVisitStatusPage={() => {
            stopPolling();
            navigate('/customer-setting/status/unblock');
          }}
          opened={modal.opened}
          variant={modal.variant} withCloseButton={false} />}

      {modal.variant === 'limitCsv' &&
        <RenderModalLimitMaxCsv
          message={<>Maksimal jumlah NIK pelanggan yang dapat diproses <strong>
            100.000 NIK pelanggan</strong>
            . Perbarui file data pelanggan dan coba lagi.</>}
          onClose={() => setModal({
            opened: false,
            variant: modal.variant,
            actionType: modal.actionType
          })}
          opened={modal.opened}
        />}
    </Card>
  );
};

export default NikActivateBulk;
